import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';

const LabTab = ({ items, label }) => {
  const [value, setValue] = React.useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', typography: 'body1', pt: 2 }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', backgroundColor: '' }}>
          <TabList
            onChange={handleChange}
            aria-label="lab API tabs example"
            centered
            textColor="inherit"
            sx={{
              '& .MuiTab-root': {
                color: 'text.primary',
                fontWeight: 600
              },
              '& .Mui-selected': {
                color: 'text.primary'
              }
            }}>
            {items.length > 0 && (
              <Tab
                label={label}
                value="1"
                sx={{ color: 'text.primary', fontWeight: 600, fontSize: 16 }}
                textColor="inherit"
              />
            )}
          </TabList>
        </Box>
        <TabPanel value="1" sx={{ px: { xs: 2, md: 3 } }}>
          {/* Match the product body text style (the summary list): secondary grey,
              gold disc markers, body1 typography, and a readable measure instead of
              a full-bleed line. */}
          <List
            sx={{
              listStyleType: 'disc',
              maxWidth: '72ch',
              mx: 'auto',
              pl: '24px',
              color: 'text.primary',
              '& li::marker': { color: 'gold.fill' }
            }}
            disablePadding>
            {items?.map((i, idx) => (
              <ListItem
                key={idx}
                disableGutters
                sx={{ display: 'list-item', typography: 'body1', py: 0.5 }}>
                {i}
              </ListItem>
            ))}
          </List>
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default LabTab;
